export default class RequestInfoModalUtils {
  isReadOnly: boolean;
  authorName: string;
  name: string;
  date: string;
  content: string;
  constructor(params) {
    this.isReadOnly = this.isModalReadOnly(params.requestInfo);
    this.authorName = params.requestInfo.author_name;
    this.content = params.requestInfo.content;
    this.name = params.name;
    this.date = params.requestInfo.date;
  }

  isModalReadOnly = requestInfo => Object.keys(requestInfo).length > 0;

  setTitle = () => (this.isReadOnly ? 'REQUEST MORE INFO SENT' : 'REQUEST MORE INFORMATION');

  setSubtitle = () =>
    this.isReadOnly
      ? `Information requested by Curator: ${this.authorName}`
      : `Ask ${this.name} for more information`;

  setDetails = () => (this.isReadOnly ? 'Details:' : '');

  setDate = () => (this.isReadOnly ? this.date : '');

  props = () => ({
    isReadOnly: this.isReadOnly,
    title: this.setTitle(),
    subtitle: this.setSubtitle(),
    details: this.setDetails(),
    content: this.content,
    date: this.setDate(),
  });
}
